import React from 'react';

import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';
import { PromoButton } from '../PromoButton/PromoButton';
import { PromoDangerouslyHtml } from '../PromoDangerouslyHtml/PromoDangerouslyHtml';
import { PromoText } from '../PromoText/PromoText';
import PromoIllustration from '../widgets/Illustration/PromoIllustration';

const CommonCss = css`
    display: inline-block;
    height: 100%;
    border-radius: 12px;
    padding: 6px;
    box-sizing: border-box;

    ${promoMedia.tablet744} {
        border-radius: 24px;
        padding: 16px;
    }

    img {
        border: none;
        max-width: 100%;
        vertical-align: top;
        border-radius: 12px;

        ${promoMedia.tablet744} {
            border-radius: 24px;
        }
    }
`;
const ListingTileLink = styled.a`
    ${CommonCss};
    cursor: pointer;
    border: none;
    outline: none;
    text-decoration: none;

    &:hover {
        background: ${promoColors.purple5};
    }
`;
const ListingTileDiv = styled.div`
    ${CommonCss};
    cursor: ${(props) => (props.onClick ? 'pointer' : null)};

    &:hover {
        background: ${(props) => (props.onClick ? promoColors.purple5 : 'transparent')};
    }
`;
const ImgContainer = styled.span`
    display: inline-block;
    margin-bottom: ${(props) => (props.hasText ? '12px' : null)};
`;
const Title = styled.div`
    margin-bottom: 8px;
`;

const Subtitle = styled.div`
    margin-top: 8px;
`;

const LearnMoreButton = styled.div`
    margin-top: 8px;
`;

const getComponent = (props) => {
    if (props.linkText) {
        return ListingTileLink;
    } else {
        return ListingTileDiv;
    }
};

export const ListingTile = (props) => {
    const Wrapper = getComponent(props);
    return (
        <Wrapper title={props.title} onClick={props.onClick} href={props.linkUrl}>
            {props.img && (
                <ImgContainer hasText={props.title || props.subtitle}>
                    <PromoIllustration img={props.img} loadingLazy={props.loadingLazy} />
                </ImgContainer>
            )}
            {props.title && (
                <Title>
                    <PromoText color={'baseColor'} tag="div" variant={'subheader'}>
                        {props.title}
                    </PromoText>
                </Title>
            )}
            {props.subtitle && (
                <Subtitle>
                    <PromoDangerouslyHtml color={'gray40'} dangerouslyHtml={props.subtitle} tag={'div'} />
                </Subtitle>
            )}
            {props.linkText && (
                <LearnMoreButton>
                    <PromoButton variant="tertiary" type="pseudo" caption={props.linkText} />
                </LearnMoreButton>
            )}
        </Wrapper>
    );
};

ListingTile.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
    img: PropTypes.array,
    onClick: PropTypes.func,
    loadingLazy: PropTypes.bool,
};
